
<template>
    <div>
        <v-card class="main-card" v-if="!$AuthSvc.isLogin()">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">Registration</span>
            </v-card-title>
            <span>Must login to register</span>
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreCard !== null && tournament.status === 'REGISTER'">
            <v-card-text v-if="tournament!==null">
                <span class="label18">Congratulations!</span><br/><br/>
                <span class="label14">You have registered for {{tournament.course.name}}.</span>
                <span v-if="scoreCard.owe > 0">
                    <br>
                    You still owe the amount of ${{scoreCard.owe}}.<br>
                    <span v-if="scoreCard.paymentType!=='Complimentary'">
                        You preferred to pay by {{scoreCard.paymentType}}.
                    </span>
                    <span v-if="scoreCard.paymentType==='Complimentary'">
                        Your payment selection is Complimentary and requires an approval.
                    </span>
                    <br>
                </span>

                <span v-if="scoreCard.paymentType==='Complimentary' && fee > 0">
                    <br/>
                    PLEASE BE AWARE: <br>
                    If you choose "Complimentary", the DFWVGA President/Treasurer will review your
                    enrollment and MUST approve your complement fee before the deadlline.<br/>
                    Please contact Vincent Tran at (682) 703-6172 if you have any questions.
                    <br>
                </span>
                <span v-if="scoreCard.paymentType==='Zelle' && tournament.formatType==='TOURNAMENT' && scoreCard.owe > 0">
                    <br/>
                    Please ZELLE to <b>pay@dfwvga.com</b> before the deadline.
                    <br/>
                </span>

                <br>

                <span v-if="scoreCard.owe > 0">
                    All dues MUST BE PAID before the deadline {{printDateTime(tournament.registrationDeadline)}}
                    in order to participate in the banquet, otherwise your registration will be CANCELLED and awarded to
                    standby's.
                    <br> <br>
                </span>

                <span class="label14" v-if="scoreCard.owe === 0">
                    <br>
                    See you at the party!
                </span>
            </v-card-text>

        </v-card>

        <v-card class="no-login" v-if="$AuthSvc.isLogin() && tournament === null">
            <v-card-title style="padding-bottom:0">
                <span class="page-title">Registration</span>
            </v-card-title>
                    No banquets to register at this time.
        </v-card>

        <v-card class="main-card" v-if="$AuthSvc.isLogin() && scoreCard === null && tournament !== null">
            <v-card style="padding: 20px" class="mx-auto mt-5">
                <v-card-title>
                    <span class="page-title">Registration</span>
                </v-card-title>
                <br>

                <v-card class="registration-card">
                    <v-card-text v-if="tournament!==null">
                        <span class="label14">Event: </span> {{tournament.course.name}} <br/>
                        <span class="label14">Schedule Date: </span> {{printDateTime(tournament.scheduleDate)}} <br/><br/>

                        <span class="label14">Name: </span> {{$AuthSvc.getFullName()}} <br/>
                        <span class="label14">Email: </span> {{$AuthSvc.getUserInfo().email}} <br/>
                        <span class="label14">Member Status: </span> {{$AuthSvc.getUserInfo().status}}<br/>
                        <br/>
                        <div style="width: 100%">
                            <span class="label16">Member Fee: </span>
                            <span> FREE : +1 Guest FREE</span>
                        </div>

                        <div>
                            <span class="label16">Guest Fee: </span>
                            <span>${{tournament.guestFee}}</span> &nbsp; &nbsp;
                        </div>

                    </v-card-text>
                </v-card>

                <v-card-text>
                    <br/><br/>
                    <v-form>
                        <v-card-label style="margin-top: 30px">
                            Do you have Guest(s)?
                        </v-card-label>
                        <v-container fluid>
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="guestSelection" @change="onGuestChange()"
                                              :items="numGuestSelections"
                                              label="Select Number Of Guest(s)"
                                    ></v-select>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-container fluid>
                            <v-row v-for="idx in banquetGuests.length" :key="idx">
                                <v-col>
                                    Enter Full Name Guest {{idx}}: <v-text-field v-model="banquetGuests[idx-1]"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-container>

                        <v-card-label style="margin-top: 30px">Payment Selection</v-card-label>

                        <v-container fluid>
                            <v-row align="center">
                                <v-col class="d-flex" cols="12" sm="16">
                                    <v-select v-model="paymentType"
                                              :items="paymentTypeSelections"
                                              label="Payment Type"
                                    ></v-select>
                                </v-col>

                            </v-row>
                        </v-container>

                        <br><br>
                        <span class="label16">Total Fee: ${{fee}} </span>
                    </v-form>
                </v-card-text>
                <v-card-actions class="actions-card">
                    <v-btn style="background-color:darkgreen;color:white;" @click="formSubmit()">Register</v-btn>
                </v-card-actions>
            </v-card>

        </v-card>

    </div>
</template>

<script>
import moment from 'moment';
import swal from 'sweetalert';

  export default {
    name: "login",
    data: () => ({
      JUNIOR_FEE: 50,
      membershipFeeCost: 0,
      membershipSelection: 'Not at this time',
      memberFee: 0,
      fee: 0,
      lateFee: 0,
      hioFee: 0,
      totalPlayers: 0,
      paymentType: 'Select One',
      tournament: null,
      userInfo: null,
      scoreCard: null,
      specialRequest: '',
      banquetGuests: [],
      totalGuests: 0,
      paymentTypeSelections: [
        "Select One",
        "Zelle",
        "Complimentary"
      ],
      numGuestSelections: [
        "0 - No Guests",
        "1 - Guest",
        "2 - Guests",
        "3 - Guests",
        "4 - Guests",
        "5 - Guests",
        "6 - Guests",
        "7 - Guests",
        "8 - Guests"
      ]
    }),
    mounted: function () {
        var _this = this;
        _this.userInfo = this.$AuthSvc.getUserInfo();
        this.proximity = this.$AuthSvc.getUserInfo().proximity;
        if (this.proximity===null) {
            this.proximity = '';
        }

        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get('id')
        if (id !== null && id !== '') {
            _this.$CommandSvc.get(_this, '/public/tournament-course/' + id, function(data) {
                if (data !== null) {
                    _this.tournament = data.tournament;
                    _this.tournament.course = data.course;
                    window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
                    _this.loadScoreCard();
                }
            });
        }
        else {
            _this.$CommandSvc.get(_this, '/public/tournaments/status/REGISTER', function (data) {
                if (data.length === 1) {
                    _this.tournament = data[0].tournament;
                    _this.tournament.course = data[0].course;
                    window.sessionStorage.setItem('selectTournament', JSON.stringify(_this.tournament));
                    _this.loadScoreCard();
                }
            });
        }
    },
    methods: {
      hasProximity() {
        return this.$AuthSvc.getUserInfo().proximity !== null && this.$AuthSvc.getUserInfo().proximity !== '';
      },
      printDateTime(date) {
          return moment(date).format('MMMM Do hh:mm A');
      },
      printDate(date) {
          return moment(date).format('MMM Do');
      },
      isBanquet() {
          if (this.tournament !== null) {
              return this.tournament.formatType === 'BANQUET';
          }

          return false;
      },
      isEarly(ts) {
        var now = moment();
        return now.isBefore(ts)
      },
      loadScoreCard() {
          var _this = this;

          this.totalGuests = 0;
          this.JUNIOR_FEE = this.tournament.juniorFee==='' ? 50 : Number(this.tournament.juniorFee);

          if (_this.userInfo !== null && _this.tournament !== null) {
              this.axios.get('/public/scores/players/' + _this.tournament.tournamentId + '/' + _this.userInfo.playerId)
                  .then(function (response) {
                      if (response.data !== null && response.data != "") {
                          _this.scoreCard = response.data;
                      }
                      _this.onChange();
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });

              this.axios.get('/public/scores/players/' + _this.tournament.tournamentId + '/count')
                  .then(function (response) {
                      _this.totalPlayers = response.data;
                      if (_this.totalPlayers >= _this.tournament.limitSize) {
                          _this.paymentType = 'StandBy';
                      }
                  })
                  .catch(function (error) {
                      console.log('ERROR: ' + error);
                  });
          }
      },
      onGuestChange() {
        this.fee = 0;
        let guestFee = Number(this.tournament.guestFee);

        this.banquetGuests = [];
        let numGuests = Number(this.guestSelection.substr(0,1));

        if (!this.$AuthSvc.isMember()) {
            this.fee = guestFee + (numGuests * guestFee);
        }
        else {
            if (numGuests <= 1) {
                this.fee = 0;
            }
            else {
                this.fee = this.fee + ((numGuests-1) * guestFee);
            }
        }

        for(var i=0; i < numGuests; i++) {
            this.banquetGuests.push('');
        }
      },
      validateForm() {
          if (this.banquetGuests.length > 0) {
            let i;
            for(i=0; i < this.banquetGuests.length; i++) {
                if (this.banquetGuests[i] === '') {
                    swal("Need More Info", "Please enter guest name.", "info");
                    return false;
                }
            }
          }

          return true;
      },
      formSubmit() {
          var _this = this;

          if (!this.validateForm()) {
            return;
          }

          this.specialRequest = '';
          if (this.banquetGuests.length > 0) {
                this.specialRequest =  this.banquetGuests.join(", ");
          }
          let numGuests = Number(this.guestSelection.substr(0,1));
          var userInfo = this.$AuthSvc.getUserInfo();
          var scoreCard = {
            playerId: userInfo.playerId,
            tournamentId: this.tournament.tournamentId,
            flight: userInfo.flight,
            isOfficial: false,
            isRegister: true,
            fee: this.fee,
            lateFee: numGuests,
            memberFee: this.membershipFeeCost,
            holeInOne: this.hioFee,
            birdieHunt: this.birdieHunt,
            owe: this.fee,
            paymentType: this.paymentType,
            specialRequest: this.specialRequest,
            member: this.$AuthSvc.isMember()?'Y':'N',
            playTeebox: this.playTeebox
          };

          this.axios.post('/api/tournaments/registration', scoreCard)
          .then(function (response) {
              _this.scoreCard = response.data;
          })
          .catch(function (error) {
              swal("Error", "Registration failed.", "error");
              console.log('ERROR: ' + error);
          });
      },
    }
  }
</script>

<style scoped>
  .v-card {
    background-color: #e6f2ea;
  }

  .registration-card {
    padding: 10px;
    margin-bottom: 20px;
  }

  .registration-card * {
    font-size: 14px;
  }

  .v-checkbox, .v-input {
    margin: 0;
    padding: 0;
  }


  .login {
    margin-top: 12px;
    width: 100%;
  }

  .actions-card {
    margin-top: 20px;
  }

  @media (min-width: 768px) {

  }

</style>